module.exports = __webpack_public_path__ + "static/img/TAKAMAZFEELER.9c724969.png";